<template>
  <div>
    <b-table striped :items="platforms" small :fields="platformFields" :busy="ordersLoading">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="5"><h5>Orders - ${{ platformTotal }}</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(site)="data">
        <span v-if="!data.value">(none)</span>

        <b-link v-else @click="siteLink(data.value)">{{ data.value }}</b-link>
        </template>

        <template #cell(amount)="data">
        <span class="text-success">${{ formatPrice(data.value) }}</span>
        </template>

        <template #cell(itemCount)="data">
          <b-link v-if="data.value > 0" @click="siteItemsLink(data.item.site)">{{ data.value }}</b-link>
          <span v-else>{{ data.value }}</span>
        </template>
    </b-table>

    <b-table striped sticky-header="300px" no-border-collapse
                :items="orderSources" small :fields="orderSourceFields" :busy="ordersLoading"
                class="mt-5">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="5"><h5>Sources</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(source)="data">
        <span v-if="!data.value">(none)</span>
        <span v-else>{{ data.value }}</span>
        </template>

        <template #cell(count)="data">
        <span>{{ data.value }}</span>
        </template>

        <template #cell(amount)="data">
        <span class="text-success">${{ formatPrice(data.value) }}</span>
        </template>

         <template #cell(itemCount)="data">
          <b-link v-if="data.value > 0 && data.item.source" @click="sourceItemsLink(data.item.source, data.item.itemIds)">{{ data.value }}</b-link>
          <span v-else>{{ data.value }}</span>
        </template>
    </b-table>

    <b-table striped sticky-header="300px" no-border-collapse
                :items="orderUsers" small :fields="orderUserFields" :busy="ordersLoading"
                class="mt-5">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="5"><h5>Users</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(username)="data">
        <span v-if="!data.value">(none)</span>
        <span v-else>{{ data.value }}</span>
        </template>

        <template #cell(count)="data">
        <span>{{ data.value }}</span>
        </template>

        <template #cell(amount)="data">
        <span class="text-success">${{ formatPrice(data.value) }}</span>
        </template>

         <template #cell(itemCount)="data">
          <b-link v-if="data.value > 0" @click="orderAddedItemsLink(data.item.username)">{{ data.value }}</b-link>
          <span v-else>{{ data.value }}</span>
        </template>
    </b-table>

    <b-table striped sticky-header="300px" no-border-collapse
                :items="genres" small :fields="genreFields" :busy="ordersLoading"
                class="mt-5">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="5"><h5>Genres</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(genre)="data">
        <span v-if="!data.value">(none)</span>
        <span v-else>{{ data.value }}</span>
        </template>

        <template #cell(count)="data">
        <span>{{ data.value }}</span>
        </template>

        <template #cell(amount)="data">
        <span class="text-success">${{ formatPrice(data.value) }}</span>
        </template>

         <template #cell(itemCount)="data">
          <b-link v-if="data.value > 0" @click="genreItemsLink(data.item.genre)">{{ data.value }}</b-link>
          <span v-else>{{ data.value }}</span>
        </template>
    </b-table>

    <b-table striped sticky-header="300px" no-border-collapse
                :items="formats" small :fields="formatFields" :busy="ordersLoading"
                class="mt-5">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="5"><h5>Formats</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(genre)="data">
        <span v-if="!data.value">(none)</span>
        <span v-else>{{ data.value }}</span>
        </template>

        <template #cell(count)="data">
        <span>{{ data.value }}</span>
        </template>

        <template #cell(amount)="data">
        <span class="text-success">${{ formatPrice(data.value) }}</span>
        </template>

         <template #cell(itemCount)="data">
          <b-link v-if="data.value > 0" @click="formatsLink(data.item.itemIds)">{{ data.value }}</b-link>
          <span v-else>{{ data.value }}</span>
        </template>
    </b-table>

    <b-table striped :items="shipments" small :fields="shipmentFields" :busy="ordersLoading" class="mt-5">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="3"><h5>Shipments</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(count)="data">
          <b-link
            v-if="data.value > 0 && data.item.username"
            @click="shipmentOrdersLink(data.item)"
          >
            {{ data.value }}
          </b-link>
          <span v-else>{{ data.value }}</span>
        </template>
    </b-table>
  </div>
</template>

<script>
  import statsApi from "@/api/stats";
  import utils from "@/mixins/utils";

  export default {
    name: 'OrderStats',
    mixins: [ statsApi, utils ],
    props: [ 'from', 'to', 'refresh' ],
    data() {
      return {
        platforms: [],
        shipments: [],
        orderSources: [],
        orderUsers: [],
        genres: [],
        formats: [],
        platformFields: [
          { key: 'site', label: 'Platform'  },
          { key: 'itemCount', label: 'Items'  },
          { key: 'amount', label: 'Amount'  },
        ],
        shipmentFields: [
          { key: 'username', label: 'User'  },
          { key: 'count', label: 'Shipped'  },
        ],
        orderSourceFields: [
          { key: 'source', label: 'Source'  },
          { key: 'itemCount', label: 'Items'  },
          { key: 'amount', label: 'Amount'  },
        ],
        orderUserFields: [
          { key: 'username', label: 'User'  },
          { key: 'itemCount', label: 'Items'  },
          { key: 'amount', label: 'Amount'  },
        ],
        genreFields: [
          { key: 'genre', label: 'Genre'  },
          { key: 'itemCount', label: 'Items'  },
          { key: 'amount', label: 'Amount'  },
        ],
        formatFields: [
          { key: 'format', label: 'Format'  },
          { key: 'itemCount', label: 'Items'  },
          { key: 'amount', label: 'Amount'  },
        ],
        ordersLoading: false,
      }
    },
    methods: {
      siteLink(site) {
        let query = { orderDate: this.from, platform: site };

        if (this.to) {
          query['orderDateTo'] = this.to;
        }

        this.$router.push({ name: 'orders', params: { outsideQuery: { filters: query } } })
      },
      siteItemsLink(site) {
        console.log(site);
        let query = { platform: site, orderDate: this.from };

        if (this.to) {
          query['orderDateTo'] = this.to;
        }

        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      shipmentOrdersLink(shipment) {
        if (!shipment || !shipment.username) {
          return;
        }

        const filters = {
          shipDate: this.from,
          shippedBy: shipment.username,
        };
        if (this.to) {
          filters.shipDateTo = this.to;
        }

        this.$router.push({
          name: 'orders',
          params: {
            outsideQuery: {
              filters,
            },
          },
        });
      },
      sourceItemsLink(source, itemIds) {
        let query; 
        if (itemIds.length > 0) {
          query = { itemIds: itemIds.join(',') };
        } else { 
          query = { orderSource: source, orderDate: this.from }
          if (this.to) {
            query['orderDateTo'] = this.to;
          }
        }
        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      orderAddedItemsLink(username) {
        console.log(username);
        let query = { orderAddedBy: username, orderDate: this.from };

        if (this.to) {
          query['orderDateTo'] = this.to;
        }

        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      genreItemsLink(genre) {
        let query = { genre: genre, orderDate: this.from };
        if (this.to) {
          query['orderDateTo'] = this.to;
        }
        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      formatsLink(itemIds) {
        let query = { itemIds: itemIds.join(',') };
        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      async getStats() {
        this.ordersLoading = true;

        try {
            const orderStats = await this.fetchOrderStats(this.from, this.to);
            this.platforms = orderStats.platforms;
            this.shipments = orderStats.shipments;
            this.orderSources = orderStats.sources;
            this.orderUsers = orderStats.users;
            this.genres = orderStats.genres;
            this.formats = orderStats.formats;
        } catch (err) {
            this.showError(err, 'Order Stats');
        } finally {
            this.ordersLoading = false;
        }
      },
    },
    computed: {
      platformTotal() {
        let price = 0;

        this.platforms.forEach(p => {
          if (!isNaN(p.amount)) {
            price += p.amount;
          }
        });

        return price.toLocaleString();
      },
    },
    watch: {
      from() {
        this.getStats();
      },
      to() {
        this.getStats();
      },
      refresh() {
        this.getStats();
      }
    }
  }
</script>

<style scoped>
  .table thead tr:first-child th {
    border-top: 0;
  }
</style>